import { Button, PasswordField, TextField } from "@aws-amplify/ui-react";
import { useForm } from "react-hook-form";
import AuthFormShell from "./AuthFormShell";

export interface SignInFormValues {
  email: string;
  password: string;
}

interface SignInFormProps {
  onSubmit: (values: SignInFormValues) => void;
  onForgotPassword: () => void;
  onDismissError?: () => void;
  error?: string | null;
  isLoading?: boolean;
}

const SignInForm = ({ onSubmit, onForgotPassword, onDismissError, error, isLoading }: SignInFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SignInFormValues>({ mode: "onSubmit" });

  return (
    <AuthFormShell
      heading="Sign in to your account"
      onSubmit={handleSubmit(onSubmit)}
      error={error}
      onDismissError={onDismissError}
      fields={
        <>
          <TextField
            label="Email"
            placeholder="Enter your Email"
            type="email"
            autoComplete="username"
            {...register("email", { required: "Email is required" })}
            hasError={!!errors.email}
            errorMessage={errors.email?.message}
          />
          <PasswordField
            label="Password"
            placeholder="Enter your Password"
            autoComplete="current-password"
            {...register("password", { required: "Password is required" })}
            hasError={!!errors.password}
            errorMessage={errors.password?.message}
          />
        </>
      }
      actions={
        <>
          <Button type="submit" variation="primary" isFullWidth isLoading={isLoading}>
            Sign in
          </Button>
          <Button type="button" variation="link" onClick={onForgotPassword} className="amplify-button--link">
            Forgot your password?
          </Button>
        </>
      }
    />
  );
};

export default SignInForm;
